/**
 * Maanmittauslaitos open WMTS raster basemaps.
 *
 * The tile URL and its api-key were copy-pasted across every map component;
 * this is the one definition. Source/layer ids are prefixed `mml-` so they
 * cannot clash with the Mapbox style's own layers, but MML's layer names are
 * unprefixed — passing an id straight into the tile URL yields 404s, hence
 * the lookup table.
 */
const MML_API_KEY = "9396425f-0fe1-4631-adc9-a3f6621fcbcb";

// Names the source rather than one layer: the same string is attached to
// maastokartta, taustakartta and ortokuva alike, so citing "Maastokartta"
// mislabels the other two.
export const MML_ATTRIBUTION = "© Maanmittauslaitos (NLS), CC BY 4.0";

export const MML_TILE = (layer: string) =>
  `https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/${layer}/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png?api-key=${MML_API_KEY}`;

export const MML_BASEMAPS = {
  "mml-maastokartta": "maastokartta",
  "mml-taustakartta": "taustakartta",
  "mml-ortokuva": "ortokuva",
} as const;

export type MmlBasemapId = keyof typeof MML_BASEMAPS;

export type BasemapId = "mapbox" | MmlBasemapId;

export const MML_LAYER_IDS = Object.keys(MML_BASEMAPS) as MmlBasemapId[];
